import React, { useEffect } from "react";
import { Card, Container } from "react-bootstrap";
import visionmainimg1 from "../../assets/images/visionmainimage (1).webp";
import visionmainimg2 from "../../assets/images/visionmainimage (2).webp";
import visionmainimg3 from "../../assets/images/visionmainimage (3).webp";
import visionmainimg4 from "../../assets/images/visionmainimage (4).webp";
import visionimg1 from "../../assets/images/ourvissonimage1.webp";
import visionimg2 from "../../assets/images/ourvissonimage2.webp";
import visionimg3 from "../../assets/images/vision3.png"
import { Swiper, SwiperSlide } from "swiper/react";
import { FaRoad } from "react-icons/fa6";
import { Pagination, EffectFade, Autoplay } from "swiper/modules";

export const OurvisionCard = () => {
  const images = [
    {
      id: 1,
      img: visionmainimg1,
    },
    {
      id: 2,
      img: visionmainimg2,
    },
    {
      id: 3,
      img: visionmainimg3,
    },
    {
      id: 4,
      img: visionmainimg4,
    },
  ];

  return (
    <div className="home-vissonbg" style={{ overflow: "hidden", paddingTop: "100px", paddingBottom: "30px" }}>
      <Container>
        <div className="row pt-3 gap-4">
          <div className="d-flex flex-column flex-lg-row gap-3">
            <div
              className="col-md-12 col-lg-6 mt-md-0"
              style={{ position: "relative" }}
            >
              <div className="d-none d-lg-block blog-redsquareimage"></div>
              <div className="h-100">
                <Swiper
                  pagination={true}
                  slidesPerView={1}
                  autoplay={{ delay: 2000 }}
                  effect={"fade"}
                  loop
                  modules={[Pagination, EffectFade, Autoplay]}
                  className="vission-main-image"
                >
                  {images?.map((img, i) => (
                    <SwiperSlide key={i}>
                      <img
                        src={img.img}
                        className="img-fluid slide-image"
                        alt={`slide-${i}`}
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
            <div
              className="col-md-12 col-lg-6 pb-5 ps-md-5 them-font"
              data-aos="fade-left"
            >
              <div className="pb-2 px-3">
                <div>
                  <h2 className="text-md-end fw-semibold text-sm-start">
                    Our Vision
                  </h2>
                </div>
                <div>
                  <h4 className="text-md-end text-sm-start fs-6">
                    Leading with honesty and efficiency, Kesaria Textile Company is building a global legacy.
                  </h4>
                </div>
                <div>
                  <div className="d-flex text-end gap-2">
                    <div>
                      <div className="vission-f6">Legacy and Innovation</div>
                      <p className="vission-f7">
                        Kesaria Textile is redefining Surat’s heritage through innovative, elegant sarees.
                      </p>
                    </div>
                    <div>
                      <img
                        src={visionimg1}
                        className="vission-main-redimage my-3"
                        data-aos="zoom-in"
                      />
                    </div>
                  </div>
                  <div className="d-flex text-end gap-2">
                    <div>
                      <div className="vission-f6">
                        Community and Empowerment
                      </div>
                      <p className="vission-f7">
                        At Kesaria Textile, every saree tells the story of a Surat artisan’s pride and passion.
                      </p>
                    </div>
                    <div>
                      <img
                        src={visionimg2}
                        className="vission-main-redimage my-3"
                        data-aos="zoom-in"
                      />
                    </div>
                  </div>
                  <div className="d-flex text-end gap-2">
                    <div>
                      <div className="vission-f6">
                        Global Reach with Local Roots
                      </div>
                      <p className="vission-f7">
                        Kesaria weaves the spirit of Surat into sarees that cross oceans and touch hearts.
                      </p>
                    </div>
                    <div>
                      <img
                        src={visionimg3}
                        className="vission-main-redimage  my-3"
                        data-aos="zoom-in"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};
